module.exports = __webpack_public_path__ + "static/media/RadwegSperreMichelhausen.fa188773.webp";